<template>
  <div
    ref="columnEl"
    class="layout_column one_column"
    :class="[
      col_num,
      has_system_module ? 'has_system_module' : '',
      column.children == 0 ? 'no_module' : ''
    ]"
    :id="'u' + column.widgets_id"
    :data-id="column.widgets_id"
    :data-index="col_index"
    :data-order="column.data.mb_infor.order"
    :rowType="column.rowType"
    name="layout_column"
    :pid="column.pid"
    :col="column.data[$store.state.app.view_pattern + '_infor'].col"
    :data-type="has_system_module ? 'has_system_module' : ''"
    :style="{
        backgroundColor: background_obj.background_set.radio_val !== 'hidden' ? background_obj.background_set[background_obj.background_set.radio_val].color : '',
        borderColor: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_color : '',
        borderStyle: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_style : '',
        borderLeftWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_left_width + 'px' : '',
        borderRightWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_right_width + 'px' : '',
        borderTopWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_top_width + 'px' : '',
        borderBottomWidth: border_obj.border_set.radio_val !== 'hidden' ? border_obj.border_set[border_obj.border_set.radio_val].border_bottom_width + 'px' : '',
        backgroundImage:background_obj.background_set.radio_val !== 'hidden' && background_obj.background_set[background_obj.background_set.radio_val].img !== '' ? 'url('+background_obj.background_set[background_obj.background_set.radio_val].img+')' : 'none',
        boxShadow: infor.is_shadow == 'true' ? 'rgba(0, 0, 0, 0.15) 0px 0px 12px 0px': '0 0 0 #fff',
        backgroundSize: background_obj.background_set.radio_val !== 'hidden' ? background_obj.background_set[background_obj.background_set.radio_val].background_size: 'auto',
        backgroundRepeat: background_obj.background_set.radio_val !== 'hidden' ?background_obj.background_set[background_obj.background_set.radio_val].background_repeat: 'repeat',
        backgroundPosition: background_obj.background_set.radio_val !== 'hidden' ?background_obj.background_set[background_obj.background_set.radio_val].background_position : '0% 0%',
        paddingLeft: padding_obj.padding_left,
        paddingRight: padding_obj.padding_right,
        paddingTop: padding_obj.padding_top,
        paddingBottom: padding_obj.padding_bottom,
        marginLeft: $store.state.app.view_pattern === 'pc' ? infor.margin_left : 0,
        marginRight: $store.state.app.view_pattern === 'pc' ? infor.margin_right : 0,
        marginTop: margin_obj.margin_top,
        marginBottom: margin_obj.margin_bottom,
        order:$store.state.app.view_pattern === 'mb' && col_order_val === 'custom' ? column.data.mb_infor.order : 0,
        ...columnStyle
    }"
  >
    <!--has_system_module 代表这个列下面，是否存在系统挂件-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="col_edit_frame"
        :class="column.data[$store.state.app.view_pattern + '_infor'].col <= 3 ? 'col_edit_top' : ''"
        v-if="isEdit"
      ></div>
    </template>

    <!--列宽度缩放(pc独有)-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div class="column_resize_handle" v-if="isEdit">
        <div class="column_resize_handle_icon"></div>
      </div>
      <div class="column_resize_border" v-if="isEdit"></div>
    </template>

    <span
      class="column_operation_line"
      v-show="column.children && column.children.length == 0 ? true : false"
    >
      <div class="hover_border_top"></div>
      <div class="hover_border_left"></div>
      <div class="hover_border_right"></div>
      <div class="hover_border_bottom"></div>
    </span>

    <!--添加模块(pc独有)-->
    <template v-if="$store.state.app.view_pattern === 'pc'&&!material_tag">
      <div
        class="column_no_child_frame"
        v-if="column.children && column.children.length == 0 ? true : false"
      >
        <div class="column_no_child">
          <div class="child_frame">
            <el-button plain type="primary" @click.stop="add_module">
              <i class="web_col_content_empty_tips_icon"></i>{{$t('widgets_layout_column_index_2931')}}</el-button>
            <p>{{$t('widgets_layout_column_index_2932')}}</p>
            <p>{{$t('widgets_layout_column_index_2933')}}</p>
          </div>
        </div>
      </div>
    </template>

    <template v-if="$store.state.app.edit_column && column.widgets_id == $store.state.app.edit_column.widgets_id">
      <div class="col_handler_line col_handler_line_top"></div>
      <div class="col_handler_line col_handler_line_right"></div>
      <div class="col_handler_line col_handler_line_bottom"></div>
      <div class="col_handler_line col_handler_line_left"></div>
    </template>

    <div
      class="modules sort_modules"
      :data-id="column.widgets_id"
      :data-index="col_index"
      :rowType="column.rowType"
      :class="[
        row.data.is_system == 'true' ? 'system_col_sort_modules' : '',
        column.rowType === 'header' ? 'header_col' : '',
        column.rowType === 'body' ? 'body_col' : '',
        column.rowType === 'footer' ? 'footer_col' : '',
        column.rowType == 'header' && row_has_basic_loginregister ? 'header_row_col' : ''
       ]"
    >
      <basic_module
        :row1="row1"
        :row="row"
        :column="column"
        :module="module"
        v-for="(module,i) in column.children"
        :key="module.widgets_id"
        :module_index="i"
      >
        <component
          slot="content"
          :row="row"
          :row1="row1"
          :column="column"
          :module="module"
          :module_index="i"
          :is="module.name"
        ></component>
      </basic_module>
    </div>

  </div>
</template>

<script>
import i18n from '../../language/index'

import basic_module from '../basic_module/index'
import {
  create_col_style
} from '@/base/col_style_data';

export default {
  name: 'layout_column',
  props: {
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    row1: {
      type: Object,
      default: null,
    },
    col_index: {
      type: Number,
      default: 0
    },
    material_tag: {
      type: Boolean,
      defaults: false
    },
    banner_id: {
      type: Number
    },
    col_order_val: {
      type:String,
      default: 'default'
    }
  },
  data() {
    return {
      isColInBasicRowTab: false,
      isSticky: false,
      stickyWidth: 0,
      stickyLeft: 0,
    }
  },
  computed: {
    has_system_module() {
      let r = false
      for (let i = 0; i < this.column.children.length; i++) {
        const module = this.column.children[i]
        if (
          module.data.is_system === 'true' ||
          module.data.isSystem === 'true'
        ) {
          r = true
          break
        }
      }
      return r
    },
    infor() {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.column.data.pc_infor;
      } else {
        return this.column.data.mb_infor
      }
    },
    isEdit() {
      if (this.column.newType === 'col2') {
        return this.templet.row_is_edit(this.row1)
      } else {
        return this.templet.row_is_edit(this.row)
      }
    },
    background_obj() {
      return this.data_judge(this.column.data.mb_infor.background_set.radio_val);
    },
    border_obj() {
      return this.data_judge(this.column.data.mb_infor.border_set.radio_val);
    },
    padding_obj() {
      return this.data_judge(this.column.data.mb_infor.padding_pattern);
    },
    margin_obj() {
      return this.data_judge(this.column.data.mb_infor.margin_pattern);
    },
    col_num() {
      return this.templet.calculation_col_num(this.column, this.row);
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    slideLength() {
      let num = this.$store.state.myRender.body.length
      let pageNum = this.$store.state.myRender.private.banner_isShow ? num + 1 : num
      return pageNum
    },
    columnStyle() {
      if (this.isColInBasicRowTab) {
        return {}
      }
      if (this.column.isNewCol || this.column.newType === 'col1' || this.column.newType === 'col2') {
        return {}
      }
      let style = {}
      let isEmptyRow = this.column.children.length === 0
      if (this.isFullPage && isEmptyRow && this.row.rowType === 'body') {
        let headerIsShow = String(this.$store.state.myRender.common.header_display) === 'true'
        let footerIsShow = String(this.$store.state.myRender.common.footer_display) === 'true'
        let headerIsXuanfu = this.$store.state.myRender.private.fullPageTopNavType === 'xuanfu'
        let headerIsFixed = String(this.$store.state.myRender.common.fixed_header) === 'true'
        let fullPageCurrentIndex = this.$store.state.app.fullPageCurrentIndex
        let isLastPage = this.$store.state.myRender.body[this.$store.state.myRender.body.length - 1].widgets_id === this.row.widgets_id
        let height = $(window).height() - $('.topBar').height()
        if ((headerIsShow && (headerIsFixed || fullPageCurrentIndex == 0))) {
          if (headerIsXuanfu) {
            style.top = ($('.myheader').height() + 1) + 'px'
          }
          height = height - $('.myheader').height()
        }
        if (footerIsShow && isLastPage) {
          height = height - $('.myFooter').height()
        }
        style.height = height + 'px'
      }
      return style

    },
    row_has_basic_loginregister() {
      return this.row.rowType === 'header' && this.templet.row_has_module(this.row, 'basic_loginregister');
    },
    stickyEnabled() {
      if (this.$store.state.app.view_pattern !== 'pc' ||
        this.column.data.pc_infor.is_sticky !== 'true') {
        return false
      }
      const siblings = this.row.children
      if (!siblings) return false
      for (let i = 0; i < siblings.length; i++) {
        if (siblings[i].widgets_id !== this.column.widgets_id &&
          siblings[i].data.pc_infor.is_sticky !== 'true') {
          return true
        }
      }
      return false
    },
    stickyTopOffset() {
      let top = 0
      if (this.$store.state.app.topBarVisible) {
        top += this.$store.state.app.topBarHeight || 0
      }
      if (String(this.$store.state.myRender.common.fixed_header) === 'true') {
        const headerEl = document.querySelector('.myheader-contain')
        if (headerEl) {
          top += headerEl.offsetHeight || 0
        }
      }
      top += parseInt(this.column.data.pc_infor.sticky_top) || 0
      return top
    },
  },
  components: {
    basic_module
  },
  watch: {
    stickyEnabled(val) {
      if (val) {
        this.$nextTick(() => this.initStickyListener())
      } else {
        this.removeStickyState()
        this.destroyStickyListener()
      }
    }
  },
  methods: {
    add_module() {
      if (this.isEdit) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_layout_column_index_2934')
        })
      } else {
        this.$store.commit('left_sidebar/set_dialog', true)
        this.$store.commit('left_sidebar/set_active', 'module')
        this.$store.commit('left_sidebar/set_module_tab_active', 'module')
        this.$store.commit('app/set_addModule_col', this.column.widgets_id)
      }
    },
    edit_column() {
      this.$store.commit('app/SET_module_Data', this.column)
      this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
      this.$store.commit('main_dialog/Change_edit_name', this.column.name)
    },
    data_judge(mb_radio_val) {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.column.data.pc_infor
      } else {
        if (mb_radio_val === 'default') {
          return this.column.data.pc_infor;
        } else {
          return this.column.data.mb_infor
        }
      }
    },
    applyFixedStyle() {
      const el = this.$el
      const rect = el.getBoundingClientRect()
      this.stickyWidth = rect.width
      this.stickyLeft = rect.left

      const cs = window.getComputedStyle(el)
      const placeholder = document.createElement('div')
      placeholder.className = 'layout_column_sticky_placeholder'
      placeholder.style.height = rect.height + 'px'
      placeholder.style.flex = cs.flex
      placeholder.style.width = cs.width
      placeholder.style.marginLeft = cs.marginLeft
      placeholder.style.marginRight = cs.marginRight
      placeholder.style.marginTop = cs.marginTop
      placeholder.style.marginBottom = cs.marginBottom
      el.parentNode.insertBefore(placeholder, el.nextSibling)
      this._stickyPlaceholder = placeholder

      el.style.position = 'fixed'
      el.style.top = this.stickyTopOffset + 'px'
      el.style.left = this.stickyLeft + 'px'
      el.style.width = this.stickyWidth + 'px'
      el.style.marginLeft = '0'
      el.style.marginRight = '0'
      el.style.marginTop = '0'
      el.style.marginBottom = '0'
      el.style.zIndex = '100'
      el.classList.add('layout_column_fixed')

      this._stickyContentHeight = el.offsetHeight
    },
    clearFixedStyle() {
      const el = this.$el
      el.style.position = ''
      el.style.top = ''
      el.style.left = ''
      el.style.width = ''
      el.style.zIndex = ''
      el.style.marginLeft = ''
      el.style.marginRight = ''
      el.style.marginTop = ''
      el.style.marginBottom = ''
      el.style.maxHeight = ''
      el.style.overflow = ''
      el.classList.remove('layout_column_fixed')

      if (this._stickyPlaceholder) {
        this._stickyPlaceholder.remove()
        this._stickyPlaceholder = null
      }
    },
    handleStickyScroll() {
      if (!this.stickyEnabled) return

      if (this._rafId) {
        cancelAnimationFrame(this._rafId)
      }

      this._rafId = requestAnimationFrame(() => {
        this._rafId = null
        this._handleStickyScrollCore()
      })
    },
    _handleStickyScrollCore() {
      const el = this.$el
      const parentRow = $(el).closest('.laybox_child_frame')[0]
      if (!parentRow) return

      const topOffset = this.stickyTopOffset

      if (!this.isSticky) {
        const rect = el.getBoundingClientRect()

        if (rect.top <= topOffset - 1) {
          this.applyFixedStyle()
          this.isSticky = true
          this.updateStickyPosition(parentRow, topOffset)
        }
      } else {
        // 使用占位元素的位置来判断是否该解除吸顶（fixed 元素的 rect.top 始终在吸顶位置）
        const refEl = this._stickyPlaceholder || el
        const refRect = refEl.getBoundingClientRect()

        if (refRect.top > topOffset + 1) {
          this.clearFixedStyle()
          this.isSticky = false
          return
        }

        this.updateStickyPosition(parentRow, topOffset)
      }
    },
    updateStickyPosition(parentRow, topOffset) {
      const el = this.$el

      const siblings = parentRow.querySelectorAll(':scope > .layout_column, :scope > .layout_column_new_box')
      let siblingsMaxBottom = -Infinity
      let hasSiblings = false
      for (let i = 0; i < siblings.length; i++) {
        const sib = siblings[i]
        if (sib === el) continue
        hasSiblings = true
        const sibBottom = sib.getBoundingClientRect().bottom
        if (sibBottom > siblingsMaxBottom) {
          siblingsMaxBottom = sibBottom
        }
      }

      const parentRect = parentRow.getBoundingClientRect()
      const containerBottom = hasSiblings ? siblingsMaxBottom : parentRect.bottom

      const contentHeight = this._stickyContentHeight || el.offsetHeight
      const stickyBottom = topOffset + contentHeight

      if (stickyBottom > containerBottom) {
        el.style.top = (containerBottom - contentHeight) + 'px'
      } else {
        el.style.top = topOffset + 'px'
      }

      const maxVisibleHeight = containerBottom - Math.max(parseFloat(el.style.top) || topOffset, 0)
      if (maxVisibleHeight > 0 && contentHeight > maxVisibleHeight) {
        el.style.maxHeight = maxVisibleHeight + 'px'
        el.style.overflow = 'hidden'
      } else {
        el.style.maxHeight = ''
        el.style.overflow = ''
      }
    },
    initStickyListener() {
      if (!this.stickyEnabled) return
      this.destroyStickyListener()
      this._stickyScrollContainer = $(this.$el).closest('.my_page_main')[0] || window
      this._stickyHandler = this.handleStickyScroll.bind(this)
      this._stickyScrollContainer.addEventListener('scroll', this._stickyHandler, { passive: true })
      window.addEventListener('resize', this._stickyResizeHandler = () => {
        if (this.isSticky) {
          this.removeStickyState()
        }
      })
      if (window.ResizeObserver) {
        this._stickyResizeObserver = new ResizeObserver(() => {
          if (!this.isSticky) return
          const el = this.$el
          // 当 maxHeight 裁剪生效时，不更新占位高度和自然内容高度
          if (!el.style.maxHeight) {
            if (this._stickyPlaceholder) {
              this._stickyPlaceholder.style.height = el.offsetHeight + 'px'
            }
            this._stickyContentHeight = el.offsetHeight
          }
        })
        this._stickyResizeObserver.observe(this.$el)
      }
    },
    destroyStickyListener() {
      if (this._rafId) {
        cancelAnimationFrame(this._rafId)
        this._rafId = null
      }
      if (this._stickyHandler) {
        if (this._stickyScrollContainer) {
          this._stickyScrollContainer.removeEventListener('scroll', this._stickyHandler)
        }
        this._stickyHandler = null
      }
      if (this._stickyResizeHandler) {
        window.removeEventListener('resize', this._stickyResizeHandler)
        this._stickyResizeHandler = null
      }
      if (this._stickyResizeObserver) {
        this._stickyResizeObserver.disconnect()
        this._stickyResizeObserver = null
      }
    },
    removeStickyState() {
      if (this.isSticky) {
        this.clearFixedStyle()
      }
      this.isSticky = false
    },

  },
  created() {
    if (typeof this.column.data.mb_infor.background_set == "undefined") {
      this.$set(this.column.data, 'mb_infor', {
        col: 1,
        order: 0,
        ...create_col_style()
      })
    }
    if (typeof this.column.data.pc_infor.padding_pattern == "undefined") {
      this.$set(this.column.data.pc_infor, 'padding_pattern', 'default')
      this.$set(this.column.data.pc_infor, 'margin_pattern', 'default')
      this.$set(this.column.data.pc_infor, 'margin_top', '0%')
      this.$set(this.column.data.pc_infor, 'margin_bottom', '0%')
      this.$set(this.column.data.pc_infor, 'margin_left', '0%')
      this.$set(this.column.data.pc_infor, 'margin_right', '0%')
    }
    if (typeof this.column.data.pc_infor.is_sticky == "undefined") {
      this.$set(this.column.data.pc_infor, 'is_sticky', 'false')
      this.$set(this.column.data.pc_infor, 'sticky_top', '0')
    }
  },
  mounted() {
    if ($(this.$el).parents('.basic_row_tab').length) {
      this.isColInBasicRowTab = true
    }
    this.templet.module_sortable(this.column.widgets_id)
    if (this.stickyEnabled) {
      this.$nextTick(() => this.initStickyListener())
    }
  },
  beforeDestroy() {
    this.destroyStickyListener()
    this.removeStickyState()
  }
}
</script>

<style lang="scss">
@import '~@/css/global-variable.scss';

.layout_column_fixed {
  min-height: auto !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.layout_column {

  .col_edit {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);

    .separator {
      width: 1px;
      height: 16px;
      background: #f5f5f5;
    }

    p {
      padding: 0 10px;
      cursor: pointer;

      &:hover {
        color: $theme-primary;
      }
    }

    .set {
      width: 30px;
      height: 30px;
      font-size: 0;

      &:nth-of-type(1) {
        margin-left: 10px;
      }

      i {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(~@/assets/image/cssSprite.png) no-repeat;
        cursor: pointer;
        &.left {
          background-position: -782px -111px;
        }

        &.right {
          background-position: -841px -111px;
        }

        &.close {
          background-position: -418px -111px;
        }

        &:hover {
          background-position-y: -66px;
        }

        &.disabled {
          background-position-y: -111px;
          opacity: 0.5;
        }
      }
    }
  }

  .column_resize_handle {
    z-index: 100;
    position: absolute;
    top: 10%;
    right: -4px;
    width: 9px;
    height: 80%;
    border-radius: 2px;
    background: #666;
    cursor: ew-resize;

    &:hover {
      background: #5874d8;
    }

    &::before {
      display: none;
      content: '调整列宽度';
      position: absolute;
      top: 50%;
      margin-top: -13px;
      left: 20px;
      width: 70px;
      padding: 2px 8px;
      border: 1px solid #f5e4b9;
      font-size: 13px;
      line-height: 21px;
      color: #333;
      background-color: #fffaee;
      border-radius: 2px;
    }

    &:hover::before {
      display: block;
    }

    .column_resize_handle_icon {
      position: absolute;
      top: 50%;
      margin-top: -2px;
      width: 9px;
      height: 5px;
      background: url(~@/assets/image/mbg01.png) -254px -46px no-repeat;
    }
  }

  .column_no_child_frame {
    .el-button {
      font-size: 15px;
      background-color: rgba(202, 214, 255, 0.1);
      cursor: pointer;

      span {
        display: flex;
        justify-content: center;
        align-items: center;

        .web_col_content_empty_tips_icon {
          display: inline-block;
          width: 17px;
          height: 14px;
          margin-right: 11px;
          background: url(~@/assets/image/cssSprite.png) no-repeat;
          background-position: -1302px -74px;
          vertical-align: middle;
        }
      }

      &:hover .web_col_content_empty_tips_icon {
        background-position: -1302px -120px;
      }
    }
  }

  .col_handler_line {
    position: absolute;
    z-index: 11;
  }

  .col_handler_line_top {
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    border-top: 3px dashed #5874d8;
  }

  .col_handler_line_right {
    top: 0;
    right: 0;
    width: 0;
    height: 100%;
    border-right: 3px dashed #5874d8;
  }

  .col_handler_line_bottom {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    border-bottom: 3px dashed #5874d8;
  }

  .col_handler_line_left {
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    border-left: 3px dashed #5874d8;
  }
}
</style>


// WEBPACK FOOTER //
// src/widgets/layout_column/index.vue